import { Grid, IconButton, Stack, Typography } from '@mui/material';
import { DeviceInfo } from '../DeviceInfo';
import { SectionHeader } from './SectionHeader';
import { asDateWithTimezone } from '../../util/DateFormat';
import LinkIcon from '@mui/icons-material/Link';

export function GeneralDetails({ test }) {
  const copyLink = () => {
    //get root path
    const link = window.location.origin + '/testDetails/' + test.uuid;

    navigator.clipboard.writeText(link);
  };

  let timeSinceSymptoms = null;
  if (test.patientDetails.medicalHistory.symptomsOnset) {
    let diffMs = (new Date(test.createdAt) - new Date(test.patientDetails.medicalHistory.symptomsOnset));
    let diffDays = Math.floor(diffMs / 86400000);
    let diffHrs = Math.floor((diffMs % 86400000) / 3600000);
    let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
    let daysStr = Intl.NumberFormat('en', { style: 'unit', unit: 'day', unitDisplay: 'short' }).format(diffDays);
    let hoursStr = Intl.NumberFormat('en', { style: 'unit', unit: 'hour', unitDisplay: 'short' }).format(diffHrs);
    let minutesStr = Intl.NumberFormat('en', { style: 'unit', unit: 'minute', unitDisplay: 'short' }).format(diffMins);
    timeSinceSymptoms = "Since symptoms - " + [daysStr, hoursStr, minutesStr].join(", ")
  }

  return (
    <>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={12}>
          <Stack direction="row" spacing={1} alignItems="baseline">
            <SectionHeader name="Test Details" />
            <DeviceInfo deviceDescription={test.deviceDescription} />
          </Stack>
        </Grid>
        <Grid item xs={2}>
          <Typography>ID</Typography>
        </Grid>
        <Grid item xs={10}>
          <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
            <IconButton aria-label="copyLink" size="small" onClick={copyLink}>
              <LinkIcon />
            </IconButton>

            <Typography sx={{ textAlign: 'right' }}>{test.uuid}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={1}>
          <Typography>Patient</Typography>
        </Grid>
        <Grid item xs={11}>
          <Typography sx={{ textAlign: 'right' }}>{test.patientDetails?.name}</Typography>
        </Grid>

        {test.patientDetails.medicalHistory.symptomsOnset && (
          <>
            <Grid item xs={5}>
              <Typography>Time of symptoms onset</Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography sx={{ textAlign: 'right' }}>{asDateWithTimezone(test.patientDetails.medicalHistory.symptomsOnset)}</Typography>
            </Grid>
          </>
        )}

        <Grid item xs={5}>
          <Typography>Time of test</Typography>
        </Grid>
        <Grid item xs={7}>
          <Typography sx={{ textAlign: 'right' }}>{asDateWithTimezone(test.createdAt)}</Typography>
          {timeSinceSymptoms && (
            <Typography sx={{ textAlign: 'right' }}>{timeSinceSymptoms}</Typography>
          )}
        </Grid>
      </Grid>
    </>
  );
}
